import { useQueryClient } from '@zg-rentals/react-query5';
import { type RentalManagerUserPropertyCreateWebApiHandler_create_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { useRentalManagerUserPropertyCreateWebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { getPropertiesQueryKey } from './useGetProperties';
import type { ListingType, PropertyType } from '@zg-rentals/ts-rental-manager-api-client';

export interface CreatePropertyRequest {
  listingType: ListingType;
  fullAddress: string;
  propertyType: PropertyType;
  unitNumber?: string;
}

export interface CreatePropertyResponse {
  listingAlias: string;
  duplicateListingAlias?: string;
}

export function useCreateProperty(options?: RentalManagerUserPropertyCreateWebApiHandler_create_Options) {
  const queryClient = useQueryClient();

  return useRentalManagerUserPropertyCreateWebApiHandler_create({
    ...options,
    onSuccess: async (...args) => {
      await options?.onSuccess?.(...args);
      queryClient.invalidateQueries({
        queryKey: getPropertiesQueryKey(),
      });
    },
  });
}
